<template>
	<footer
		class="footer declined-footer"
		:class="{ 'declined-footer--dark': darkTheme }"
	>
		<div class="check-footer-holder">
			<primary-button
				class="button"
				outlined
				large
				:dark-theme="darkTheme"
				@click="$emit('cancel-order')"
			>
				Cancel Order
			</primary-button>
			<div class="footer-error">
				<span class="title">Credit card has been declined by bank.</span>
			</div>
			<primary-button
				class="button"
				large
				@click="$emit('open-credit-card-modal')"
			>
				Use Other Card
			</primary-button>
		</div>
		<div class="check-footer-holder-mobile">
			<div class="footer-error">
				<span class="title">Credit card has been declined by bank.</span>
			</div>
			<div class="check-footer-buttons-holder">
				<primary-button
					class="button"
					outlined
					large
					:dark-theme="darkTheme"
					@click="$emit('cancel-order')"
				>
					Cancel Order
				</primary-button>
				<primary-button
					class="button"
					large
					@click="$emit('open-credit-card-modal')"
				>
					Use Other Card
				</primary-button>
			</div>
		</div>
	</footer>
</template>

<script>
import PrimaryButton from '@/components/Buttons/PrimaryButton.vue'

export default {
	name: 'CheckDeclinedFooter',
	components: { PrimaryButton },

	props: {
		darkTheme: {
			type: Boolean,
			default: false
		}
	}
}
</script>

<style lang="scss">
@import './src/assets/styles/variables';

.declined-footer {
	padding-top: 24px;

	.check-footer-holder {
		display: flex;
		justify-content: space-between;
		align-items: center;
		max-width: 100%;
		margin: 0;

		.button {
			width: 192px;
			margin: 0 0 0 10px;

			&:first-child {
				margin: 0 10px 0 0;
			}
		}
	}

	.check-footer-holder-mobile {
		display: none;
	}

	&--dark {
		background: $background-box !important;
		color: $white;
	}
}

.footer-error {
	max-width: 190px;
	font-size: 12px;
	color: #e9576a;
	text-align: center;
	flex-grow: 1;

	.title {
		display: block;
		font-weight: 700;
	}

	p {
		margin: 0;
	}
}

@media (max-width: 767px) {
	.declined-footer {
		.check-footer-holder {
			display: none;
		}

		.check-footer-holder-mobile {
			display: block;
			padding: 0 20px 12px 20px;

			.check-footer-buttons-holder {
				display: flex;
				justify-content: space-between;
			}
		}

		.button {
			min-width: 160px;
		}
	}

	.footer-error {
		max-width: none;
		display: block;
		text-align: center;
		padding: 0 0 10px;

		.title {
			font-size: 14px;
			padding: 0 0 6px;
		}
	}
}
</style>
